var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.43 17.09"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72 11.33a5.67 5.67 0 1 1 5.67-5.67 5.67 5.67 0 0 1-5.67 5.67Zm0-9.33a3.67 3.67 0 1 0 3.67 3.67A3.67 3.67 0 0 0 8.72 2ZM16.43 17.08a1 1 0 0 1-.59-.19 12.11 12.11 0 0 0-7.12-2.28 12 12 0 0 0-7.14 2.28 1 1 0 1 1-1.17-1.61 14 14 0 0 1 8.18-2.67h.28A14 14 0 0 1 17 15.28a1 1 0 0 1-.59 1.81Z"
  })));
};
export default SvgUser;